import React from 'react';
import clsx from "clsx";
import ExpandoMenu from '../../../../../../ui_components/ExpandoMenu/ExpandoMenu';
import ShowText from '../../../../../../shared_components/Info/ShowText/ShowText';
import ButtonSize from '../../../../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../../../../ui_components/Button/ButtonType';
import { useStyles } from '../CustomCategorySalePrices.style';
import CustomCategorySalePriceRowProperties from './CustomCategorySalePriceRowProperties';
import ShowIntervalWithTitle from '../../../../../../shared_components/Info/ShowIntervalWithTitle/ShowIntervalWithTitle';
import { CurrencyModule } from '../../../../../../util/Currency';
import Currency from '../../../../../../entities/Currency';
import { useI18nContext } from '../../../../../../contexts/I18nContext';
import NewPackageCustomCategoryWeightRangeSalePriceButton from '../../../../../../shared_components/Buttons/NewPackageCustomCategoryWeightRangeSalePriceButton/NewPackageCustomCategoryWeightRangeSalePriceButton';
import RemovePackageCustomCategoryWeightRangeSalePriceButton from '../../../../../../shared_components/Buttons/RemovePackageCustomCategoryWeightRangeSalePriceButton/RemovePackageCustomCategoryWeightRangeSalePriceButton';

const CustomCategorySalePriceRowMedium: React.FC<CustomCategorySalePriceRowProperties> = ({
                                                            customCategoryWeightRangeSalePrice,
                                                            salePrice,
                                                            onUpdate = () => {
                                                            },
                                                        }) => {

    const classes = useStyles();
    const i18n = useI18nContext();

    return (
        <div className={clsx(classes.package_sale_prices_info_container)}>
            <ShowIntervalWithTitle title={i18n.translate("WEIGHT_RANGES_RANGE")} from={customCategoryWeightRangeSalePrice.from} to={customCategoryWeightRangeSalePrice.to}/>
            <ShowText text={CurrencyModule.format(customCategoryWeightRangeSalePrice.salePrice, Currency.DOLLAR)} title={i18n.translate("WEIGHT_RANGES_PRICE")}/>
            <ExpandoMenu>
                <>
                    <NewPackageCustomCategoryWeightRangeSalePriceButton
                       size={ButtonSize.SMALL}
                       onSave={onUpdate}
                       showText
                       salePriceId={salePrice?.id ?? ''}
                       customCategoryId={customCategoryWeightRangeSalePrice.customCategoryId}
                       salePriceCustomCategoryWeightRange={customCategoryWeightRangeSalePrice}
                       type={ButtonType.SECONDARY}
                   />
                   <RemovePackageCustomCategoryWeightRangeSalePriceButton
                        size={ButtonSize.SMALL} onSave={onUpdate}
                        salePriceId={salePrice?.id ?? ''}
                        salePriceCustomCategoryWeightRange={customCategoryWeightRangeSalePrice}
                        showText
                        type={ButtonType.SECONDARY}
                   />
                </>
            </ExpandoMenu>
        </div>
    )
}

export default CustomCategorySalePriceRowMedium;
